import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/context";
import { businessHelper } from '../helpers'

export const useGetAll = () => {
    const { userInfoQursiva, logOut } = useContext(AuthContext);
    /* Sin sesión real `userInfoQursiva === false`; destructurar
       `false.tokenQursiva` lanzaba y crasheaba cualquier consumidor
       (p.ej. HomeBusinessGrid en el home del invitado). El endpoint
       academy/business/all no exige token, así que `undefined` basta. */
    const token = userInfoQursiva ? userInfoQursiva.tokenQursiva : undefined;
    const [ data, setData ] = useState([]);
    const [ isLoading, setIsLoading ] = useState(true)

    useEffect(()=> {
        businessHelper.getAll(token, logOut)
            .then( response => {
                setData(response);
                setIsLoading(false)
            })
    },[token, logOut])

    return {
        isLoading, data
    }
}